import { render, staticRenderFns } from "./NoticeMobile.vue?vue&type=template&id=7871258a&scoped=true&"
import script from "./NoticeMobile.vue?vue&type=script&lang=js&"
export * from "./NoticeMobile.vue?vue&type=script&lang=js&"
import style0 from "./NoticeMobile.vue?vue&type=style&index=0&id=7871258a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7871258a",
  null
  
)

export default component.exports